<template>
  <div
    class="d-flex flex-row"
    style="gap: 12px"
    >
    <v-text-field
      :disabled="paymentType.id"
      style="max-width: 200px; min-width: 200px"
      v-model="name"
      label="Nombre"
      outlined
      dense
      class="rounded-lg"
      ></v-text-field>

    <v-select
      :disabled="paymentType.id"
      style="max-width: 200px; min-width: 200px"
      v-model="currency"
      label="Moneda"
      outlined
      dense
      class="rounded-lg"
      :items="['ARS', 'USD']"
      ></v-select>

    <v-text-field
      v-model="amount"
      label="Monto"
      outlined
      dense
      hint="Si es un egreso, el monto debe ser negativo."
      class="rounded-lg"
      ></v-text-field>

    <div
      style="margin-top: 2px"
      >
      <v-btn
        icon
        color="error lighten-2"
        :disabled="!paymentType.id"
        @click="deletePaymentType"
        >
        <v-icon>
          mdi-delete
        </v-icon>
      </v-btn>

      <v-btn
        icon
        color="success"
        @click="createPaymentType"
        >
        <v-icon>
          mdi-check-circle
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { CreatePaymentType, DeletePaymentType } from '@/graphql/mutations/receipts'

export default {
  data: () => ({
    amount: 0,
    currency: 'ARS',
    name: 'Efectivo'
  }),

  props: {
    paymentType: {
      type: Object,
      required: true
    },
    id: {
      type: Number | String,
      required: true
    }
  },

  created () {
    this.name = this.paymentType.name
    this.amount = this.paymentType.amount
    this.currency = this.paymentType.currency
  },

  methods: {
    createPaymentType () {
      this.$emit('loading', true)
      this.$apollo.mutate({
        mutation: CreatePaymentType,
        variables: {
          input: {
            receiptId: this.id,
            name: this.name,
            amount: this.amount,
            currency: this.currency
          }
        }
      }).then ( res => {
        this.$emit('loading', false)
        this.$nextTick( () => {
          this.$emit('added')
        })
      })
    },

    deletePaymentType () {
      this.$emit('loading', true)
      this.$apollo.mutate({
        mutation: DeletePaymentType,
        variables: {
          input: {
            id: this.paymentType.id,
          }
        }
      }).then ( res => {
        this.$emit('loading', false)

        this.$nextTick( () => {
          this.$emit('deleted', this.paymentType.id)
        })
      })
    }
  }
}
</script>
